/**
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '../BaseModel';

export class Beilage extends BaseModel {
    ident: string | null = null;
    name: string | null = null;
    path: string | null = null;
    originalFilename: string | null = null;
}
